import {create} from 'zustand';

// Zustand Store zur Berechnung und Speicherung des Gesamtumsatzes
const useRevenueStoreYear = create((set) => ({
    totalRevenue: 0,
    setTotalRevenue: (revenueData) => {
        // Berechnung des Gesamtumsatzes aus den monatlichen Daten
        const total = revenueData.reduce((acc, current) => acc + (current.revenue || 0), 0);
        set({totalRevenue: total});
    },
}));

export default useRevenueStoreYear;